module.exports = __webpack_public_path__ + "static/media/line3.79c546e1.png";